import { isLATAM } from "services/instances"
import PrannaLa from "./la"
import PrannaMx from "./mx"

const Pranna = () => (isLATAM() ? <PrannaLa /> : <PrannaMx />)

export default Pranna
